export default __webpack_public_path__ + "static/media/blue-bag-inactive.3df21231.png";